import api from './api'

// Helper to match original API interface
export const eventAPI = {
  list: async (page, pageSize, token) => {
    const response = await api.get('/events', {
      params: { page, page_size: pageSize }
    })
    return response.data
  },
  create: async (data, token) => {
    const response = await api.post('/events', data)
    return response.data
  },
  update: async (id, data, token) => {
    const response = await api.put(`/events/${id}`, data)
    return response.data
  },
  delete: async (id, token) => {
    const response = await api.delete(`/events/${id}`)
    return response.data
  }
}

export const supplierAPI = {
  list: async (page, pageSize, token) => {
    const response = await api.get('/suppliers', {
      params: { page, page_size: pageSize }
    })
    return response.data
  },
  create: async (data, token) => {
    const response = await api.post('/suppliers', data)
    return response.data
  },
  update: async (id, data, token) => {
    const response = await api.put(`/suppliers/${id}`, data)
    return response.data
  },
  delete: async (id, token) => {
    const response = await api.delete(`/suppliers/${id}`)
    return response.data
  }
}

export const setupAPI = {
  healthCheck: async (silentLoading = false) => {
    const response = await api.get('/health', { silentLoading })
    return response.data
  },
  getStatus: async (token, silentLoading = false) => {
    const response = await api.get('/setup/status', { silentLoading })
    return response.data
  },
  initDatabase: async (token) => {
    const response = await api.post('/setup/init')
    return response.data
  },
  getTableCounts: async (silentLoading = false) => {
    try {
      const response = await api.get('/setup/table-counts', { silentLoading })
      return response.data
    } catch (error) {
      // If endpoint doesn't exist, return empty object
      return {}
    }
  },
  getDatabaseSize: async (silentLoading = false) => {
    try {
      const response = await api.get('/setup/dbsize', { silentLoading })
      return response.data
    } catch (error) {
      return { size_bytes: 0, error: error.message }
    }
  },
  getTableSizes: async (silentLoading = false) => {
    try {
      const response = await api.get('/setup/table-sizes', { silentLoading })
      return response.data
    } catch (error) {
      // If endpoint doesn't exist, return empty object
      return {}
    }
  },
  getTableColumns: async (tableName, silentLoading = true) => {
    try {
      const response = await api.get(`/setup/table/${encodeURIComponent(tableName)}/columns`, { silentLoading })
      return response.data
    } catch (error) {
      return []
    }
  }
}

export const associationAPI = {
  // Integration - Event associations
  associateEvent: async (integrationId, eventId, token) => {
    const response = await api.post(`/integrations/${integrationId}/events/${eventId}/associate`)
    return response.data
  },
  disassociateEvent: async (integrationId, eventId, token) => {
    const response = await api.delete(`/integrations/${integrationId}/events/${eventId}/disassociate`)
    return response.data
  },

}
